/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { BrowserTracing } from '@sentry/tracing';
import { EnvironmentEnum } from '@core/models/enums/environment';
import { HttpErrorResponse } from '@angular/common/http';
import './overrides';
import 'hammerjs';

Sentry.init({
	dsn: environment.sentryDSN,
	integrations: [
		new BrowserTracing({
			tracePropagationTargets: ['localhost', environment.apiUrl],
			routingInstrumentation: Sentry.routingInstrumentation,
		}),
	],
	environment: environment.environment,
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate:
		environment.environment === EnvironmentEnum.Development ? 1.0 : 0.2,
	sendClientReports: false,
	beforeSend(event, hint) {
		// Handled by NgModule's ErrorHandler
		if (hint?.originalException instanceof HttpErrorResponse) {
			if (hint.originalException.status === 401) {
				return null;
			}

			return event;
		}

		return event;
	},
});

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.then(() => {
		// @ts-ignore
		window.appBootstrap && window.appBootstrap();
	});
